import Vue from 'vue'
import VueRouter from 'vue-router'
//import i18n from '../i18n'
import Login from '../views/Login.vue'
import SignUp from '../views/SignUp.vue'
import Home from '../views/Layout.vue'
import Dashboard from '../components/Dashboard/Dashboard.vue'
import AdminDashboard from '../components/Dashboard/AdminDashboard.vue'
import TermsAndCondition from '../components/TermsAndCondition/TermsAndCondition.vue'
import Main from '../components/Home/Home.vue'


//import App from '../App.vue'
import UserList from '../components/User/UsersList.vue'
import NewUser from '../components/User/RegisterUser.vue'
import UserProfileInfo from '../components/User/UserProfileInfo.vue'
import EmailVerification from '../components/User/EmailVerification.vue'
import EmailConfirmed from '../components/User/EmailConfirmed.vue'
import KycRequest from '../components/User/KycRequest.vue'
import KycApproved from '../components/User/KycApproved.vue'
import ResetPassword from '../views/ResetPassword.vue'


import AddCompany from '../components/Company/AddCompany.vue'
import Company from '../components/Company/Company.vue'
import AddCustomer from '../components/Customer/AddCustomer.vue'
import Customer from '../components/Customer/Customer.vue'
import TaxRate from '../components/TaxRate/TaxRate.vue'
import coa from '../components/COA/AddUpdateAccount.vue'

/*Bank*/
import AddBank from '../components/Bank/AddBank.vue'
import Bank from '../components/Bank/Bank.vue'


/*Package Price*/
import PackagePlan from '../components/PackagePrice/Package.vue'
import PackagePrice from '../components/PackagePrice/PackagePrice.vue'
import AddPackagePrice from '../components/PackagePrice/AddPackagePrice.vue'
import MyPackage from '../components/MyPackage/MyPackage.vue'
import RoiHistory from '../components/MyPackage/RoiHistory.vue'
import IdHistory from '../components/MyPackage/IdHistory.vue'
import CreateNewId from '../components/PackagePrice/CreateNewId.vue'

/*Package Price*/
import Deposit from '../components/Deposit/Deposit.vue'
import BuyPackages from '../components/Deposit/BuyPackageList.vue'
import AddBuyPackage from '../components/Deposit/AddBuyPackage.vue'
import BuyNewId from '../components/Deposit/CreateNewId.vue'


/*Package Price*/
import UniLevelBonus from '../components/UniLevelBonus/UniLevelBonus.vue'
import AddUniLevelBonus from '../components/UniLevelBonus/AddUniLevelBonus.vue'
import UniLevelBonusHistory from '../components/UniLevelBonus/UniLevelBonusHistory.vue'


/*Team*/
import MyTeam from '../components/Team/MyTeam.vue'
import DirectTeam from '../components/Team/DirectTeam.vue'

/*Withdrawal*/
import Withdrawal from '../components/Withdrawal/Withdrawal.vue'


/*CashVoucher*/
import CashVoucher from '../components/CashVoucher/CashVoucher.vue'

/*Notifications*/
import Notifications from '../components/Notification/Notifications.vue'


/*Reports*/
import EarningHistory from '../components/Reports/EarningHistory.vue'
import RewardBonusHistory from '../components/Reports/RewardBonusHistory.vue'


/*Payment Option*/
import PaymentOptions from '../components/PaymentOptions/PaymentOptions.vue'
import AddPaymentOption from '../components/PaymentOptions/AddPaymentOption.vue'

/*Create Ticket*/
import CreateTicket from '../components/Support/CreateTicket.vue'
import Tickets from '../components/Support/Tickets.vue'
import Correspondence from '../components/Support/Correspondence.vue'


/*Create Ticket*/
import Emails from '../components/EmailNotification/Emails.vue'
import SendEmail from '../components/EmailNotification/SendEmail.vue'


/*Package Upgrade*/
import PackageUpgrade from '../components/PackageUpgrade/PackageUpgrade.vue'
import Upgrade from '../components/PackageUpgrade/Upgrade.vue'
import UpgradePackageList from '../components/PackageUpgrade/UpgradePackageList.vue'

/*Currency*/
import AddCurrency from '../components/Currency/AddCurrency.vue'
import Currencies from '../components/Currency/Currencies.vue'

/*Daily Expenses*/
import DailyExpenses from '../components/DailyExpense/DailyExpenses.vue'
import AddDailyExpense from '../components/DailyExpense/AddDailyExpense.vue'

/*Payment Voucher*/
import PaymentVouchers from '../components/PaymentVoucher/PaymentVouchers.vue'
import AddPaymentVoucher from '../components/PaymentVoucher/AddPaymentVoucher.vue'




import VueSession from 'vue-session'


Vue.use(VueSession);
Vue.use(VueRouter);

const routes = [


    {
        path: '/',

        component:
        {
            render(c) { return c('router-view') }
        },
        children:
            [
                {
                    path: '/',
                    name: 'Login',
                    component: Login
                },
                {
                    path: '/Main',
                    name: 'Main',
                    component: Main
                },
                {
                    path: '/SignUp',
                    name: 'SignUp',
                    component: SignUp
                },
                {
                    path: '/EmailVerification',
                    name: 'EmailVerification',
                    component: EmailVerification
                },
                {
                    path: '/EmailConfirmed',
                    name: 'EmailConfirmed',
                    component: EmailConfirmed
                },
                {
                    path: '/TermsAndCondition',
                    name: 'TermsAndCondition',
                    component: TermsAndCondition
                },
                {
                    path: '/ResetPassword',
                    name: 'ResetPassword',
                    component: ResetPassword
                },
                {
                    path: '/Home',
                    name: 'Home',
                    component: Home,
                    children: [
                        {
                            path: '/Dashboard',
                            name: 'Dashboard',
                            component: Dashboard
                        },
                        {
                            path: '/AdminDashboard',
                            name: 'AdminDashboard',
                            component: AdminDashboard
                        },
                        
                        {
                            path: '/UserList',
                            name: 'UserList',
                            component: UserList
                        },
                        {
                            path: '/NewUser',
                            name: 'NewUser',
                            component: NewUser
                        },
                        {
                            path: '/Company',
                            name: 'Company',
                            component: Company
                        },
                        {
                            path: '/addcompany',
                            name: 'AddCompany',
                            component: AddCompany
                        },
                        {
                            path: '/customer',
                            name: 'Customer',
                            component: Customer
                        },
                        {
                            path: '/addCustomer',
                            name: 'AddCustomer',
                            component: AddCustomer
                        },
                        {
                            path: '/UserProfileInfo',
                            name: 'UserProfileInfo',
                            component: UserProfileInfo
                        },
                        {
                            path: '/coa',
                            name: 'coa',
                            component: coa
                        },
                        {
                            path: '/taxrate',
                            name: 'TaxRate',
                            component: TaxRate
                        },
                        {
                            path: '/AddBank',
                            name: 'AddBank',
                            component: AddBank
                        },
                        {
                            path: '/Bank',
                            name: 'Bank',
                            component: Bank
                        },
                        {
                            path: '/AddPackagePrice',
                            name: 'AddPackagePrice',
                            component: AddPackagePrice
                        },
                        {
                            path: '/PackagePrice',
                            name: 'PackagePrice',
                            component: PackagePrice
                        },
                        {
                            path: '/PackagePlan',
                            name: 'PackagePlan',
                            component: PackagePlan
                        },
                        {
                            path: '/Deposit',
                            name: 'Deposit',
                            component: Deposit
                        },
                        {
                            path: '/BuyPackages',
                            name: 'BuyPackages',
                            component: BuyPackages
                        },
                        {
                            path: '/AddBuyPackage',
                            name: 'AddBuyPackage',
                            component: AddBuyPackage
                        },
                        {
                            path: '/AddUniLevelBonus',
                            name: 'AddUniLevelBonus',
                            component: AddUniLevelBonus
                        },
                        {
                            path: '/UniLevelBonus',
                            name: 'UniLevelBonus',
                            component: UniLevelBonus
                        },
                        {
                            path: '/MyTeam',
                            name: 'MyTeam',
                            component: MyTeam
                        },
                        {
                            path: '/MyPackage',
                            name: 'MyPackage',
                            component: MyPackage
                        },
                        {
                            path: '/AddPaymentOption',
                            name: 'AddPaymentOption',
                            component: AddPaymentOption
                        },
                        {
                            path: '/PaymentOptions',
                            name: 'PaymentOptions',
                            component: PaymentOptions
                        },
                        {
                            path: '/Withdrawal',
                            name: 'Withdrawal',
                            component: Withdrawal
                        },
                        {
                            path: '/CashVoucher',
                            name: 'CashVoucher',
                            component: CashVoucher
                        },
                        {
                            path: '/RoiHistory',
                            name: 'RoiHistory',
                            component: RoiHistory
                        },
                        {
                            path: '/UniLevelBonusHistory',
                            name: 'UniLevelBonusHistory',
                            component: UniLevelBonusHistory
                        },
                        {
                            path: '/DirectTeam',
                            name: 'DirectTeam',
                            component: DirectTeam
                        },
                        {
                            path: '/Notifications',
                            name: 'Notifications',
                            component: Notifications
                        },
                        {
                            path: '/EarningHistory',
                            name: 'EarningHistory',
                            component: EarningHistory
                        },
                        {
                            path: '/CreateNewId',
                            name: 'CreateNewId',
                            component: CreateNewId
                        },
                        {
                            path: '/KycRequest',
                            name: 'KycRequest',
                            component: KycRequest
                        },
                        {
                            path: '/IdHistory',
                            name: 'IdHistory',
                            component: IdHistory
                        },
                        {
                            path: '/BuyNewId',
                            name: 'BuyNewId',
                            component: BuyNewId
                        },
                        {
                            path: '/KycApproved',
                            name: 'KycApproved',
                            component: KycApproved
                        },
                        {
                            path: '/CreateTicket',
                            name: 'CreateTicket',
                            component: CreateTicket
                        },
                        {
                            path: '/Tickets',
                            name: 'Tickets',
                            component: Tickets
                        },
                        {
                            path: '/Correspondence',
                            name: 'Correspondence',
                            component: Correspondence
                        },
                        {
                            path: '/SendEmail',
                            name: 'SendEmail',
                            component: SendEmail
                        },
                        {
                            path: '/Emails',
                            name: 'Emails',
                            component: Emails
                        },
                        {
                            path: '/PackageUpgrade',
                            name: 'PackageUpgrade',
                            component: PackageUpgrade
                        },
                        {
                            path: '/Upgrade',
                            name: 'Upgrade',
                            component: Upgrade
                        },
                        {
                            path: '/UpgradePackageList',
                            name: 'UpgradePackageList',
                            component: UpgradePackageList
                        },
                        {
                            path: '/AddCurrency',
                            name: 'AddCurrency',
                            component: AddCurrency
                        },
                        {
                            path: '/Currencies',
                            name: 'Currencies',
                            component: Currencies
                        },
                        {
                            path: '/DailyExpenses',
                            name: 'DailyExpenses',
                            component: DailyExpenses
                        },
                        {
                            path: '/AddDailyExpense',
                            name: 'AddDailyExpense',
                            component: AddDailyExpense
                        },
                        {
                            path: '/AddPaymentVoucher',
                            name: 'AddPaymentVoucher',
                            component: AddPaymentVoucher
                        },
                        {
                            path: '/PaymentVouchers',
                            name: 'PaymentVouchers',
                            component: PaymentVouchers
                        },
                        {
                            path: '/RewardBonusHistory',
                            name: 'RewardBonusHistory',
                            component: RewardBonusHistory
                        }


                    ]
                }
            ]
    }
];
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default router
